module.exports = __webpack_public_path__ + "static/media/marc-jacobs-decadence-big.62b61676.png";